import { FunctionComponent } from 'react';
import { CustomerDetailsMailsTable } from '@/pageContents/customers/details/CustomerDetailsMailsTable';
import { Customer } from '@/models/customer';

type CustomerDetailsMailsProps = {
    customer: Customer;
};

export const CustomerDetailsMails: FunctionComponent<
    CustomerDetailsMailsProps
> = ({ customer }) => {
    return <CustomerDetailsMailsTable customerId={customer.id} />;
};
